import { render, staticRenderFns } from "./prepareCourseCenter.vue?vue&type=template&id=9e1d3ffe&scoped=true"
import script from "./prepareCourseCenter.vue?vue&type=script&lang=js"
export * from "./prepareCourseCenter.vue?vue&type=script&lang=js"
import style0 from "./prepareCourseCenter.vue?vue&type=style&index=0&id=9e1d3ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1d3ffe",
  null
  
)

export default component.exports